import { Component } from '@angular/core';
import { NavigationService } from './services/navigation.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  public pages = [
    { title: 'ඡේදයක වචන', url: '/paragraph-search' },
    { title: 'ප්‍රියතම වචන', url: '/favourite' },
    { title: 'පෙර සෙවුම්', url: '/history' },
    { title: 'උදව්', url: '/help' },
    { title: 'අපි ගැන', url: '/aboutus' },
  ];

  title = '';

  constructor(private navigationService: NavigationService) {
    this.navigationService.routeData().subscribe((data) => {
      this.title = data.title;
    });
  }

}
